export const RECEIVED_USER_LISTS = "RECEIVED_USER_LISTS";
export const CREATED_USER_LIST = "CREATED_USER_LIST";
export const ADDED_TO_USER_LIST = "ADDED_TO_USER_LIST";
